export default __webpack_public_path__ + "static/media/home.439e2c01.svg";